<div class="chessboard-view-main">
  <div #wrapper class="chessboard-view-square-wrapper">
    <div id="nonResponsiveDiv" #boardContainer style="width: 400px; height: 400px"></div>
  </div>
</div>
